export default __webpack_public_path__ + "static/media/yourturn-create(mobile).bb1ea8fe.png";